<template>
  <div class="checkBox">
    <div class="list" v-for="(item,index) in arr" :key="index" @click="sel(index,item)">
      <span v-if="item.val == 0">
        <p style="background:#20A47C;"></p>
        <div :class="item.ischeck==true?'active':''">合同正常 </div>
      </span>
      <span v-if="item.val == 1">
        <p style="background:#CFBE00;"></p>
        <div :class="item.ischeck==true?'active':''">合同到期 </div>  
      </span>
      <span v-if="item.val == 2">
        <p style="background:#FF3843;"></p>  
        <div :class="item.ischeck==true?'active':''">有欠租合同 </div>  
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "checkBox",
    components: {},
    data() {
      return {
        arr:[
          {val:0,ischeck:false},
          {val:1,ischeck:false},
          {val:2,ischeck:false},
        ],
        selarr:[]
      }
    },
    methods: {
      sel(index,item){
        let arr=[...this.arr];
        let selarr=[...this.selarr];
       if(arr[index].ischeck==false){
         arr[index].ischeck=true;
         selarr.push(item)
       }else{
         arr[index].ischeck=false;
         var index11=selarr.indexOf(index)
         selarr.splice(index11,1)
 
       }
       this.arr=arr;
       for(let i in arr) {
         if(arr[i].ischeck == true){
           this.selarr.push(arr[i].val)
         }
       }
       this.$emit("changeData",this.selarr)
       this.selarr = []
       
      },
    },
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .checkBox {
    
    .list{
      display:inline-block;
      span {
        display:flex;
        margin-right: 30px;
        cursor: pointer;

        p {
          display:inline-block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          vertical-align: middle;
          margin-top: 13px;
          margin-right: 10px;
        }
        div{
          display:inline-block;
          height: 30px;
          line-height:30px;
          padding: 0 7px;
          margin-top: 5px;
        }
        .active {
          display:inline-block;
          border: 1px solid #1890ff;
          color:#1890ff;
          border-radius: 4px;
          box-sizing: border-box;
        }
      }
    }
  }
</style>
